import * as React from 'react'
import cx from 'classnames'
import { IconWrapper, IconProps, sizes } from '../../IconWrapper'
export const SpecialRequestIcon = React.forwardRef(function SpecialRequestIcon(
  props: IconProps,
  ref?: React.ForwardedRef<HTMLElement>
) {
  return (
    <IconWrapper ref={ref} {...props}>
      <>
        {
          <svg
            width={24}
            height={24}
            viewBox='0 0 24 24'
            fill='none'
            className={cx(
              'inline-block align-middle',
              sizes[props.size || 'sm'].className
            )}
          >
            <path
              d='M6 8.35a.75.75 0 000 1.5v-1.5zm8 1.5a.75.75 0 000-1.5v1.5zm-8 1.8a.75.75 0 000 1.5v-1.5zm8 1.5a.75.75 0 000-1.5v1.5zm-8 1.7a.75.75 0 000 1.5v-1.5zm6.1 1.5a.75.75 0 000-1.5v1.5zM7.8 2v-.75a.75.75 0 00-.75.75h.75zm4.5 0h.75a.75.75 0 00-.75-.75V2zm0 2.6v.75a.75.75 0 00.75-.75h-.75zm-4.5 0h-.75c0 .414.336.75.75.75V4.6zm8.45 5.7a.75.75 0 001.5 0h-1.5zM14.4 2.35a.75.75 0 000 1.5v-1.5zm-8.9 1.5a.75.75 0 100-1.5v1.5zm3.3 15.9a.75.75 0 000-1.5v1.5zm3.3-.25l-.53-.53-.192.192-.025.27.747.068zm6.4-6.4l-.53-.53.53.53zm2.2 2.2l-.53-.53.53.53zm-6.4 6.4l.106.742.247-.035.177-.177-.53-.53zm-2.1.3v.75h.053l.053-.008L12.2 22zm-.3-.3l-.747-.068-.003.034v.034h.75zM6 9.85h8v-1.5H6v1.5zm0 3.3h8v-1.5H6v1.5zm0 3.2h6.1v-1.5H6v1.5zm1.8-13.6h4.5v-1.5H7.8v1.5zM11.55 2v2.6h1.5V2h-1.5zm.75 1.85H7.8v1.5h4.5v-1.5zm-3.75.75V2h-1.5v2.6h1.5zm9.2 5.7V4.9h-1.5v5.4h1.5zm0-5.4a2.543 2.543 0 00-2.55-2.55v1.5c.586 0 1.05.464 1.05 1.05h1.5zM15.2 2.35h-.8v1.5h.8v-1.5zm-9.7 0h-.8v1.5h.8v-1.5zm-.8 0A2.543 2.543 0 002.15 4.9h1.5c0-.586.464-1.05 1.05-1.05v-1.5zM2.15 4.9v12.3h1.5V4.9h-1.5zm0 12.3a2.543 2.543 0 002.55 2.55v-1.5c-.586 0-1.05-.464-1.05-1.05h-1.5zm2.55 2.55h4.1v-1.5H4.7v1.5zm12.382-5.207l2.2 2.1 1.036-1.086-2.2-2.1-1.036 1.085zM12.63 20.03l6.4-6.4-1.06-1.06-6.4 6.4 1.06 1.06zm6.4-6.4c.107-.107.332-.107.44 0l1.06-1.06c-.693-.693-1.867-.693-2.56 0l1.06 1.06zm.44 0l.7.7 1.06-1.06-.7-.7-1.06 1.06zm.7.7c.107.107.107.333 0 .44l1.06 1.06c.693-.693.693-1.867 0-2.56l-1.06 1.06zm0 .44l-6.4 6.4 1.06 1.06 6.4-6.4-1.06-1.06zm-5.976 6.188l-2.1.3.212 1.485 2.1-.3-.212-1.486zm-1.994.292a.46.46 0 01.305.145c.14.14.145.29.145.305h-1.5c0 .216.054.515.295.755.24.24.54.295.755.295v-1.5zm.447.518l.2-2.2-1.494-.136-.2 2.2 1.494.136z'
              fill='currentColor'
            />
          </svg>
        }
      </>
    </IconWrapper>
  )
})
